import styled from 'styled-components'

export const Section = styled.div`
  margin-bottom: 35px;
  text-align: center;
`
